import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { Bar, Line } from "react-chartjs-2";
import { apiurl } from "../config/config";
import { useUser } from "../config/userProvider";
import Card from "../components/card";
import BackHeader from "../components/backHeader";
import { analytic } from "../constants/constant";
import { InfiLoader } from "../components/loader";
import { StateData } from "../constants/constant";
// import { useNavigate } from "react-router-dom";
// import { getCookie } from "../config/webStorage";
// import Input from "../components/inputContainer";
// import { LocationData } from "./locationdata";
// import { Link } from "react-router-dom";
// import Storepopup from "../components/storepopup";
// import { RxCross2 } from "react-icons/rx";
// import SegmentedDonutChart from "./segmentedDonutChart";
// import SegmentedTrafficBar from "./segmentedTrafficBar";
// import { BlackButton } from "../components/buttonContainer";

// import {
//   FaStore,
//   FaCalendarAlt,
//   FaGlobe,
//   FaMapMarkerAlt,
//   FaCity,
// } from "react-icons/fa";

function AnalyticsReport() {
  const {
    userData,
    // storeData,
    // getstoresLoading,
    // setCloseProfile,
    permissions,
  } = useUser();
  // const token = getCookie("bb_token");
  let vendorObjId = userData?.vendorDetails?.vendorObjId;

  // const [isPopupOpen, setPopupOpen] = useState(false);
  // const [pdfPopupOpen, setPdfPopupOpen] = useState(false);
  // const [todayCount, setTodayCount] = useState("00");
  // const [totalpdf, SetTotalPdf] = useState("00");
  // const [selectedRange, setSelectedRange] = useState("today");
  // const [startDate, setStartDate] = useState("");
  // const [endDate, setEndDate] = useState("");
  // const [loadingData, setLoadingData] = useState(false);
  const [selectedRange] = useState("today");
  const [startDate] = useState("");
  const [endDate] = useState("");
  const [storeData, setStoreData] = useState("");
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedState, setSelectedState] = useState("");

  // const navigate = useNavigate();

  // const handleRangeChange = (e) => {
  //   setSelectedRange(e.target.value);
  //   // Clear custom dates if another range is selected
  //   if (e.target.value !== "custom") {
  //     setStartDate("");
  //     setEndDate("");
  //   }
  // };

  // const openPopup = () => {
  //   setPopupOpen(true);
  // };

  // const closePopup = () => {
  //   setPopupOpen(false);
  // };

  // const trafficData = {
  //   title: "Website Traffic",
  //   subtitle: "Unique visitors",
  //   totalVisitors: 26751,
  //   segments: [
  //     { label: "Direct", value: 14750, color: "#1f77b4" },
  //     { label: "Organic", value: 8000, color: "#2ca02c" },
  //     { label: "Referral", value: 2500, color: "#ff7f0e" },
  //     { label: "Social", value: 1500, color: "#d62728" },
  //   ],
  // };

  const [analytics, setAnalytics] = useState();
  // const FilterHandler = () => {
  //   let data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //     period: selectedRange,
  //     startDate: startDate,
  //     endDate: endDate,
  //   });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/analytic/report/filter`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log(JSON.stringify(response.data));
  //       if (response.data?.success === true) {
  //         setAnalytics(response.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // useEffect(() => {
  //   if (selectedRange !== "customDate") {
  //     FilterHandler();
  //   }
  // }, [selectedRange, FilterHandler]);

  useEffect(() => {
    const FilterHandler = () => {
      let data = JSON.stringify({
        vendorObjId: vendorObjId,
        period: selectedRange,
        startDate: startDate,
        endDate: endDate,
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiurl}/admin/v1/analytic/report/filter`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          if (response.data?.success === true) {
            setAnalytics(response.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    if (selectedRange !== "customDate") {
      FilterHandler();
    }
  }, [selectedRange, vendorObjId, startDate, endDate]);

  // const PieData = {
  //   labels: ["Active User", "Total Users"],
  //   datasets: [
  //     loadingData
  //       ? {
  //         label: "loading data",
  //         data: [
  //           45, 100,
  //           // dashboardData?,
  //         ],
  //         backgroundColor: ["rgb(255,225,225,1)", "rgb(225,225,225,0.3)"],
  //         hoverOffset: 2,
  //       }
  //       : {
  //         label: "user data",
  //         data: [
  //           storeData?.activeUserCount,
  //           storeData?.userCount,
  //           // dashboardData?,
  //         ],
  //         backgroundColor: ["rgb(255, 99, 132)", "rgb(54, 162, 235)"],
  //         hoverOffset: 2,
  //       },
  //   ],
  // };
  // const data = {
  //   labels: ["week 1", "week 2", "week 3", "week 4"],
  //   datasets: [
  //     {
  //       label: "First dataset",
  //       data:
  //         storeData && storeData?.weeklyData.map((item) => item.count),
  //       fill: true,
  //       tension: 0.2,
  //       backgroundColor: "rgba(75,192,192,0.2)",
  //       borderColor: "rgba(75,192,192,1)",
  //     },
  //   ],
  // };
  // const dummyGraph = {
  //   labels: ["week 1", "week 2", "week 3", "week 4"],

  //   datasets: [
  //     {
  //       label: "loading dataset",
  //       data: [33, 53, 85, 41],
  //       fill: true,
  //       tension: 0.2,
  //       backgroundColor: "rgba(235, 235, 235,0.2)",
  //       borderColor: "rgba(235, 235, 235,1)",
  //     },
  //   ],
  // };

  // --------------FILTERD POPUP BY TYPE --------------------------
  const [popUpType, setPopUpType] = useState("");
  const [isOpenFiler, setIsOpenFiler] = useState(false);
  // const [filterdStores, setFilterdStores] = useState("");
  const [filterdStores] = useState("");
  // const [chooseFilteredBy, setChooseFilteredBy] = useState("");
  const [stateWeekData, setStateWeekData] = useState("");
  const [stateFilter, setStateFilter] = useState("");

  console.log("stateFilter", stateFilter);

  // const StateFilterHandler = () => {
  //   let data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //     type: popUpType,
  //     province_code: "UP",
  //   });

  //   let config = {
  //     method: "post",
  //     maxBodyLength: Infinity,
  //     url: `${apiurl}/admin/v1/analytic/report/state/action`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       if (response.data.success === true) {
  //         console.log(JSON.stringify("filterdStores State", response.data));
  //         setFilterdStores(response.data.data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // const [showFilterPopUp, setShowFilterPopUp] = useState(true);

  // const filterHandler = () => { };

  // const Select = ({
  //   children,
  //   className,
  //   label,
  //   icon,
  //   ContainerClassName,
  //   ...props
  // }) => (
  //   <div className={`${ContainerClassName}`}>
  //     {label && <Input.normal label={label} isInput={false} />}
  //     <div className=" cursor-pointer flex items-center w-full border py-2 px-2 rounded-md gap-1">
  //       {icon && <span className="text-gray-500">{icon}</span>}
  //       <select
  //         className={`${className}  pr-4 outline-none block w-full sm:text-sm rounded-md `}
  //         {...props}
  //       >
  //         {children}
  //       </select>
  //     </div>
  //   </div>
  // );

  // const [timeType, setTimeType] = useState("");

  // const { countries, states, cities } = LocationData;

  // const [advanceFilterData, setAdvanceFilterData] = useState({
  //   catalogStatus: "catalog_generated",
  //   timeType: "",
  //   selectedCountry: "",
  //   selectedState: "",
  //   selectedCity: "",
  //   startDate: "",
  //   endDate: "",
  //   week: "",
  //   month: "",
  //   quarter: "",
  //   year: "",
  // });

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setAdvanceFilterData((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));
  // };

  // =======================POPUP ANALYTICS =================
  // const [confirmationPopup, setConfirmationPopup] = useState(false);

  // const dummyGraph = {
  //   labels: ["Week 1", "Week 2", "Week 3", "Week 4"],

  //   datasets: [
  //     {
  //       label: "Dataset 1",
  //       data: [600, 300, 900, 1400],
  //       fill: true,
  //       tension: 0.2,
  //       backgroundColor: "rgba(75,192,192,0.2)", // Teal
  //       borderColor: "rgba(75,192,192,1)",
  //     },
  //     {
  //       label: "Dataset 2",
  //       data: [400, 500, 700, 1000],
  //       fill: true,
  //       tension: 0.2,
  //       backgroundColor: "rgba(255,99,132,0.2)", // Red
  //       borderColor: "rgba(255,99,132,1)",
  //     },
  //     {
  //       label: "Dataset 3",
  //       data: [200, 400, 600, 800],
  //       fill: true,
  //       tension: 0.2,
  //       backgroundColor: "rgba(54,162,235,0.2)", // Blue
  //       borderColor: "rgba(54,162,235,1)",
  //     },
  //     {
  //       label: "Dataset 4",
  //       data: [700, 600, 500, 300],
  //       fill: true,
  //       tension: 0.2,
  //       backgroundColor: "rgba(255,206,86,0.2)", // Yellow
  //       borderColor: "rgba(255,206,86,1)",
  //     },
  //   ],
  // };

  const [popupAnalics, setPopupAnalics] = useState({ type: "", data: "" });
  // const [popupAnalicsGraphType, setPopupAnalicsGraphType] = useState("");

  console.log("analytic.BrodCastLavel", analytic.BrodCastLavel);

  const [loading, setLoading] = useState(false);
  const [userAnalyticData, setUserAnalyticData] = useState("");
  // const [storeData, setStoreData] = useState("");

  // ==================================== APIS INTRIGRATION ==================================
  useEffect(() => {
    setLoading(true);

    let data = JSON.stringify({
      storeObjId: selectedStore,
      vendorObjId: vendorObjId,
      province_code: selectedState,
    });

    let storeConfig = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/analytic/report/overview/store`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(storeConfig)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          setStoreData(response.data?.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });

    let stateConfig = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/analytic/report/overview/state`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios
      .request(stateConfig)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          setStateWeekData(response.data?.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [selectedStore, selectedState, vendorObjId]);

  useEffect(() => {
    setLoading(true);
    let data = JSON.stringify({
      userObjId: userData._id,
      vendorObjId: vendorObjId,
    });

    let storeConfig = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${apiurl}/admin/v1/analytic/report/overview/user`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios
      .request(storeConfig)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        if (response.data.success) {
          setUserAnalyticData(response.data?.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, [userData._id, vendorObjId]);

  console.log("selectedStore", selectedStore);

  const CatalogData = (stateName) => {
    return {
      labels: ["week 4", "week 3", "week 2", "week 1"],
      datasets: [
        {
          label: "Generated",
          data: [
            stateName?.last4WeeksReport?.catalog_generated,
            stateName?.last3WeeksReport?.catalog_generated,
            stateName?.last2WeeksReport?.catalog_generated,
            stateName?.last1WeekReport?.catalog_generated,
          ],
          fill: true,
          tension: 0.2,
          backgroundColor: "#85A98F10",
          borderColor: "#85A98F",
        },
        {
          label: "Sent",
          data: [
            stateName?.last4WeeksReport?.catalog_sent,
            stateName?.last3WeeksReport?.catalog_sent,
            stateName?.last2WeeksReport?.catalog_sent,
            stateName?.last1WeekReport?.catalog_sent,
          ],
          fill: true,
          tension: 0.2,
          backgroundColor: "#BCCCDC10",
          borderColor: "#BCCCDC",
        },
        {
          label: "Email",
          data: [
            stateName?.last4WeeksReport?.catalog_sent_email,
            stateName?.last3WeeksReport?.catalog_sent_email,
            stateName?.last2WeeksReport?.catalog_sent_email,
            stateName?.last1WeekReport?.catalog_sent_email,
          ],
          fill: true,
          tension: 0.2,
          backgroundColor: "#A0937D10",
          borderColor: "#A0937D",
        },
        {
          label: "Whatsapp",
          data: [
            stateName?.last4WeeksReport?.catalog_sent_whatsapp,
            stateName?.last3WeeksReport?.catalog_sent_whatsapp,
            stateName?.last2WeeksReport?.catalog_sent_whatsapp,
            stateName?.last1WeekReport?.catalog_sent_whatsapp,
          ],
          fill: true,
          tension: 0.2,
          backgroundColor: "#81A26310",
          borderColor: "#81A263",
        },
        {
          label: "Downloaded",
          data: [
            stateName?.last4WeeksReport?.catalog_downloaded,
            stateName?.last3WeeksReport?.catalog_downloaded,
            stateName?.last2WeeksReport?.catalog_downloaded,
            stateName?.last1WeekReport?.catalog_downloaded,
          ],
          fill: true,
          tension: 0.2,
          backgroundColor: "#E8B86D10",
          borderColor: "#E8B86D",
        },
        {
          label: "Order placed",
          data: [
            stateName?.last4WeeksReport?.order_placed,
            stateName?.last3WeeksReport?.order_placed,
            stateName?.last2WeeksReport?.order_placed,
            stateName?.last1WeekReport?.order_placed,
          ],
          fill: true,
          tension: 0.2,
          backgroundColor: "#D2D18010",
          borderColor: "#D2D180",
        },
      ],
    };
  };

  const [storeList, setStoreList] = useState([]);

  // const fetchStores = () => {
  //   setLoading(true);
  //   let data = JSON.stringify({
  //     vendorObjId: vendorObjId,
  //   });

  //   const config = {
  //     method: "post",
  //     url: `${apiurl}/admin/v1/store/get`,
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     data: data,
  //   };

  //   axios
  //     .request(config)
  //     .then((response) => {
  //       console.log("response.data", response.data);
  //       setStoreList(response?.data?.stores);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setLoading(false);

  //       // setLoading(false);
  //     });
  // };
  // // useEffect(() => {
  // //   fetchStores();
  // // }, []);
  // useEffect(() => {
  //   if (vendorObjId) {
  //     fetchStores();
  //   }
  // }, [vendorObjId]);

  useEffect(() => {
    const fetchStores = () => {
      setLoading(true);

      let data = JSON.stringify({
        vendorObjId: vendorObjId,
      });

      const config = {
        method: "post",
        url: `${apiurl}/admin/v1/store/get`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log("response.data", response.data);
          setStoreList(response?.data?.stores);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    };

    if (vendorObjId) {
      fetchStores();
    }
  }, [vendorObjId]);

  return (
    <Layout>
      {loading && <InfiLoader />}
      {popUpType && (
        <Card.AddPopUp removePopUp={() => setPopUpType("")}>
          {/* Filters */}
          <BackHeader
            title={popUpType.replace(/_/g, " ")}
            rightSide={
              <button
                onClick={() => setIsOpenFiler(!isOpenFiler)}
                className={`border border-zinc-700 rounded-md px-5 py-1`}
              >
                {isOpenFiler ? "X" : "Filter"}
              </button>
            }
          />

          {isOpenFiler && (
            <div className=" bg-zinc-50 rounded-md p-2 mt-4">
              <p className="block text-sm font-medium text-gray-700">
                Filterd by
              </p>
              <div className="flex justify-between md:flex-nowrap flex-wrap  gap-3">
                <select
                  id="country"
                  name="country"
                  className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select Country</option>
                  {/* Options will be dynamically generated */}
                </select>
                {/* )} */}

                {/* {chooseFilteredBy === "state" && ( */}
                <select
                  id="state"
                  name="state"
                  onChange={(e) => setStateFilter(e.target.value)}
                  className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select State</option>
                  {Object.entries(StateData).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
                {/* )} */}

                {/* {chooseFilteredBy === "city" && ( */}
                <select
                  id="city"
                  name="city"
                  className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select City</option>
                  {/* Options will be dynamically generated */}
                </select>
                {/* )} */}

                {/* {chooseFilteredBy === "date" && ( */}
                <input
                  type="date"
                  id="date"
                  name="date"
                  className="border mt-1 block w-full pl-3 pr-10 py-2 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                />
                {/* )} */}
              </div>
            </div>
          )}

          <div class="relative overflow-x-auto sm:rounded-lg mt-5">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50  ">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    Store Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Store Code
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Count
                  </th>
                </tr>
              </thead>
              <tbody>
                {filterdStores &&
                  filterdStores.map((store, index) => (
                    <tr
                      key={index}
                      className="bg-white border-b hover:bg-gray-50 "
                    >
                      <th
                        scope="row"
                        className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                      >
                        {store?.storeName || "N/A"}
                      </th>
                      <td className="px-6 py-4">{store?.storeCode || "N/A"}</td>
                      <td className="px-6 py-4">{store.count}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </Card.AddPopUp>
      )}
      {/* {confirmationPopup && (
        <Card.Confirmation
          onClose={() => setConfirmationPopup(false)}
          onConfirm={() => navigate("/analytics/insights")}
          message="Are you sure "
        />
      )}
      {showFilterPopUp && (
        <Card.AddPopUp
          ClassName="h-auto "
          removePopUp={() => setConfirmationPopup(true)}
          // closeButton="false"
        >
          <div className="capitalize flex flex-col gap-2 h-fit max-h-[90vh] overflow-scroll">
            <div className="flex items-center justify-between pb-2 ">
              <div className="text-lg font-semibold text-center flex-grow">
                Filter by time and date
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 pt-3 mt-3 bg-slate-50 p-4 rounded-md">
              <label
                key="catalog_generated"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_generated"
                  className="form-radio text-blue-600"
                  checked={
                    advanceFilterData?.catalogStatus === "catalog_generated"
                  }
                  onChange={handleInputChange}
                />
                Catalog Generated
              </label>

              <label
                key="catalog_sent"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_sent"
                  className="form-radio text-blue-600"
                  checked={advanceFilterData?.catalogStatus === "catalog_sent"}
                  onChange={handleInputChange}
                />
                Catalog Sent
              </label>

              <label
                key="catalog_sent_email"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_sent_email"
                  className="form-radio text-blue-600"
                  checked={
                    advanceFilterData?.catalogStatus === "catalog_sent_email"
                  }
                  onChange={handleInputChange}
                />
                Catalog Sent Email
              </label>

              <label
                key="catalog_sent_whatsapp"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_sent_whatsapp"
                  className="form-radio text-blue-600"
                  checked={
                    advanceFilterData?.catalogStatus === "catalog_sent_whatsapp"
                  }
                  onChange={handleInputChange}
                />
                Catalog Sent WhatsApp
              </label>

              <label
                key="catalog_downloaded"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="catalog_downloaded"
                  className="form-radio text-blue-600"
                  checked={
                    advanceFilterData?.catalogStatus === "catalog_downloaded"
                  }
                  onChange={handleInputChange}
                />
                Catalog Downloaded
              </label>

              <label
                key="order_placed"
                className="flex items-center gap-2 cursor-pointer capitalize bg-white p-3 rounded-md"
              >
                <input
                  type="radio"
                  name="catalogStatus"
                  value="order_placed"
                  className="form-radio text-blue-600"
                  checked={advanceFilterData?.catalogStatus === "order_placed"}
                  onChange={handleInputChange}
                />
                Order Placed
              </label>
            </div>

            <div className="w-full bg-slate-50 p-4 rounded-md">
              <div className="w-full">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Time
                </label>
                <Select
                  value={advanceFilterData?.timeType}
                  // onChange={(e) => setTimeType(e.target.value)}
                  name="timeType"
                  onChange={handleInputChange}
                  className="block w-full bg-white  text-gray-700 rounded-md py-2 px-3 sm:text-sm"
                  ContainerSubclassName="px-0 py-0"
                >
                  <option value="" disabled>
                    Select Duration
                  </option>
                  <option value="date">Date</option>
                  <option value="range">Range</option>
                  <option value="week">Week</option>
                  <option value="month">Month</option>
                  <option value="quarter">Quarter</option>
                  <option value="year">Year</option>
                </Select>
              </div>
            </div>

            {advanceFilterData?.timeType && (
              <div className="p-3 bg-slate-50 rounded-lg  ">
                <Input.normal
                  label={advanceFilterData?.timeType}
                  isInput={false}
                />
                {advanceFilterData?.timeType === "date" && (
                  <div className="flex gap-2">
                    <input
                      type="date"
                      className="border p-2 rounded-lg w-full"
                      placeholder="Date"
                      name="date" // Bind to startDate in the state
                      value={advanceFilterData.startDate}
                      onChange={handleInputChange}
                    />
                  </div>
                )}
                {advanceFilterData?.timeType === "range" && (
                  <div className="flex gap-2">
                    <input
                      type="date"
                      className="border p-2 rounded-lg w-full"
                      placeholder="Start Date"
                      name="startDate" // Bind to startDate in the state
                      value={advanceFilterData.startDate}
                      onChange={handleInputChange}
                    />
                    <input
                      type="date"
                      className="border p-2 rounded-lg w-full"
                      placeholder="End Date"
                      name="endDate" // Bind to endDate in the state
                      value={advanceFilterData.endDate}
                      onChange={handleInputChange}
                    />
                  </div>
                )}
                {advanceFilterData?.timeType === "week" && (
                  <input
                    type="week"
                    className="border p-2 rounded-lg w-full"
                    placeholder="Select Week"
                    name="week" // Bind to week in the state
                    value={advanceFilterData.week}
                    onChange={handleInputChange}
                  />
                )}
                {advanceFilterData?.timeType === "month" && (
                  <input
                    type="month"
                    className="border p-2 rounded-lg w-full"
                    placeholder="Select Month"
                    name="month" // Bind to month in the state
                    value={advanceFilterData.month}
                    onChange={handleInputChange}
                  />
                )}
                {advanceFilterData?.timeType === "quarter" && (
                  <select
                    className="border p-2 rounded-lg w-full"
                    name="quarter" // Bind to quarter in the state
                    value={advanceFilterData.quarter}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Quarter</option>
                    <option value="Q1">Jan-Mar</option>
                    <option value="Q2">Apr-Jun</option>
                    <option value="Q3">Jul-Sep</option>
                    <option value="Q4">Oct-Dec</option>
                  </select>
                )}
                {advanceFilterData?.timeType === "year" && (
                  <select
                    className="border p-2 rounded-lg w-full"
                    name="year" // Bind to year in the state
                    value={advanceFilterData.year}
                    onChange={handleInputChange}
                  >
                    {Array.from({ length: 10 }, (_, index) => {
                      const year = new Date().getFullYear() - index;
                      return (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      );
                    })}
                  </select>
                )}
              </div>
            )}

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 bg-slate-50 p-6 rounded-lg">
              <select
                value={advanceFilterData?.selectedCountry}
                // onChange={handleCountryChange}
                onChange={handleInputChange}
                className="border p-2 rounded-lg w-full"
                name="selectedCountry"
              >
                <option value="">Select Country</option>
                {countries.map((country) => (
                  <option key={country.code} value={country.code}>
                    {country.name}
                  </option>
                ))}
              </select>

              <select
                value={advanceFilterData?.selectedState}
                // onChange={handleStateChange}
                onChange={handleInputChange}
                className="border p-2 rounded-lg w-full"
                disabled={!advanceFilterData?.selectedCountry}
                name="selectedState"
              >
                <option value="">Select State</option>
                {states[advanceFilterData?.selectedCountry]?.map((state) => (
                  <option key={state.code} value={state.code}>
                    {state.name}
                  </option>
                ))}
              </select>

              <select
                value={advanceFilterData?.selectedCity}
                // onChange={handleCityChange}
                onChange={handleInputChange}
                className="border p-2 rounded-lg w-full"
                disabled={!advanceFilterData?.selectedState}
                name="selectedCity"
              >
                <option value="">Select City</option>
                {cities[advanceFilterData?.selectedState]?.map((city) => (
                  <option key={city.code} value={city.code}>
                    {city.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex justify-center mt-5 ">
              <BlackButton handleSubmit={advanceFilterHandler} title="Apply" />
            </div>
          </div>
        </Card.AddPopUp>
      )} */}

      {popupAnalics?.type && popupAnalics?.title === "Stores" ? (
        <Card.AddPopUp
          className=""
          height="90%"
          width="w-[95%]"
          removePopUp={() => setPopupAnalics("")}
          // closeButtonClassName="border-none"
        >
          <div className="flex md:flex-row flex-col w-full h-full overflow-hidden gap-3">
            {/* Left Side */}
            <div className="w-[70%] flex flex-col justify-between rounded-lg relative">
              <div className="w-full">
                <p className="text-4xl font-semibold">{popupAnalics?.title}</p>
                <p className="text-sm text-zinc-600">
                  {popupAnalics?.subTitle}
                </p>
              </div>
              <div className="relative">
                {!storeData && (
                  <div className="bg-red-300/10 flex justify-center items-center text-3xl text-red-500/50 font-semibold w-full h-full absolute top-0 left-0 right-0 bottom-0 rounded-md">
                    Select {popupAnalics?.title}
                  </div>
                )}
                <popupAnalics.type
                  data={CatalogData(storeData)}
                  style={{ height: "", width: "100%" }}
                />
              </div>
              <div className=""></div>
            </div>
            {/* Right Side */}
            <div className="w-[30%] overflow-auto h-full border rounded-lg p-4 bg-gray-50 space-y-4">
              {/* Dropdown */}
              <div className="flex justify-end w-full">
                {/* <Select
                  className="basic-single"
                  classNamePrefix="select"
                  defaultValue={colourOptions[0]}
                  isDisabled={isDisabled}
                  isLoading={isLoading}
                  isClearable={isClearable}
                  isRtl={isRtl}
                  isSearchable={isSearchable}
                  name="color"
                  options={colourOptions}
                />
                <Select
                  value={selectedStore}
                  onChange={setSelectedStore}
                  options={storeList}
                /> */}

                <select
                  id="store"
                  name="store"
                  value={selectedStore}
                  onChange={(e) => setSelectedStore(e.target.value)}
                  className="border w-full m-1 block pl-3 pr-4 py-1 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select store</option>
                  {storeList?.map((item, index) => (
                    <option key={index} value={item?._id}>
                      {`${item?.storeDetails?.name} | ${item?.storeCode} | ${item?.storeDetails?.addressDetails?.city}`}
                    </option>
                  ))}
                </select>
              </div>
              {/* Statistics Section */}
              <div className="text-xs capitalize grid grid-cols-2  gap-4 ">
                <WeeklyReport
                  weekLabel="Week 1"
                  reportData={storeData?.last1WeekReport}
                />
                <WeeklyReport
                  weekLabel="Week 2"
                  reportData={storeData?.last2WeeksReport}
                />
                <WeeklyReport
                  weekLabel="Week 3"
                  reportData={storeData?.last3WeeksReport}
                />
                <WeeklyReport
                  weekLabel="Week 4"
                  reportData={storeData?.last4WeeksReport}
                />
              </div>
            </div>
          </div>
        </Card.AddPopUp>
      ) : popupAnalics?.type && popupAnalics?.title === "States" ? (
        <Card.AddPopUp
          className=""
          height="90%"
          width="w-[95%]"
          removePopUp={() => setPopupAnalics("")}
          closeButtonClassName="border-none"
        >
          <div className="flex w-full h-full overflow-hidden gap-3">
            {/* Left Side */}
            <div className="w-[70%] flex flex-col justify-between rounded-lg">
              <div className="w-full">
                <p className="text-4xl font-semibold">{popupAnalics?.title}</p>
                <p className="text-sm text-zinc-600">
                  {popupAnalics?.subTitle}
                </p>
              </div>
              <div className="relative">
                {!stateWeekData && (
                  <div className="bg-red-300/10 flex justify-center items-center text-3xl text-red-500/50 font-semibold w-full h-full absolute top-0 left-0 right-0 bottom-0 rounded-md">
                    Select {popupAnalics?.title}
                  </div>
                )}
                <popupAnalics.type
                  data={CatalogData(stateWeekData)}
                  style={{ height: "", width: "100%" }}
                />
              </div>
              <div className=""></div>
            </div>
            {/* Right Side */}
            <div className="w-[30%] overflow-auto h-full border rounded-lg p-4 bg-gray-50 space-y-4">
              {/* Dropdown */}
              <div className="flex justify-end">
                <select
                  id="state"
                  name="state"
                  value={selectedState}
                  onChange={(e) => setSelectedState(e.target.value)}
                  className="border m-1 block pl-3 pr-4 py-1 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select State</option>
                  {Object.entries(StateData).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
              </div>
              {/* Statistics Section */}
              <div className="text-xs capitalize grid grid-cols-2  gap-4 ">
                <WeeklyReport
                  weekLabel="Week 1"
                  reportData={stateWeekData?.last1WeekReport}
                />
                <WeeklyReport
                  weekLabel="Week 2"
                  reportData={stateWeekData?.last2WeeksReport}
                />
                <WeeklyReport
                  weekLabel="Week 3"
                  reportData={stateWeekData?.last3WeeksReport}
                />
                <WeeklyReport
                  weekLabel="Week 4"
                  reportData={stateWeekData?.last4WeeksReport}
                />
              </div>
            </div>
          </div>
        </Card.AddPopUp>
      ) : popupAnalics?.type && popupAnalics?.title === "Users" ? (
        <Card.AddPopUp
          className=""
          height="90%"
          width="w-[95%]"
          removePopUp={() => setPopupAnalics("")}
          closeButtonClassName="border-none"
        >
          <div className="flex w-full h-full overflow-hidden gap-3">
            {/* Left Side */}
            <div className="w-[70%] flex flex-col justify-between rounded-lg">
              <div className="w-full">
                <p className="text-4xl font-semibold">{popupAnalics?.title}</p>
                <p className="text-sm text-zinc-600">
                  {popupAnalics?.subTitle}
                </p>
              </div>
              <div className="relative">
                {/* {!userAnalyticData && (
                  <div className="bg-red-300/10 flex justify-center items-center text-3xl text-red-500/50 font-semibold w-full h-full absolute top-0 left-0 right-0 bottom-0 rounded-md">
                    Select {popupAnalics?.title}
                  </div>
                )} */}
                <popupAnalics.type
                  data={CatalogData(userAnalyticData)}
                  style={{ height: "", width: "100%" }}
                />
              </div>
              <div className=""></div>
            </div>
            {/* Right Side */}
            <div className="w-[30%] overflow-auto h-full border rounded-lg p-4 bg-gray-50 space-y-4">
              {/* Dropdown */}
              {/* <div className="flex justify-end">
                <select
                  id="state"
                  name="state"
                  value={selectedState}
                  onChange={(e) => setSelectedState(e.target.value)}
                  className="border m-1 block pl-3 pr-4 py-1 border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                >
                  <option value="">Select State</option>
                  {Object.entries(StateData).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
              </div> */}
              {/* Statistics Section */}
              <div className="text-xs capitalize grid grid-cols-2  gap-4 ">
                <WeeklyReport
                  weekLabel="Week 1"
                  reportData={userAnalyticData?.last1WeekReport}
                />
                <WeeklyReport
                  weekLabel="Week 2"
                  reportData={userAnalyticData?.last2WeeksReport}
                />
                <WeeklyReport
                  weekLabel="Week 3"
                  reportData={userAnalyticData?.last3WeeksReport}
                />
                <WeeklyReport
                  weekLabel="Week 4"
                  reportData={userAnalyticData?.last4WeeksReport}
                />
              </div>
            </div>
          </div>
        </Card.AddPopUp>
      ) : (
        ""
      )}

      <Container>
        <div className=" w-full h-full overflow-scroll rounded-xl  py-4 px-2">
          {/* <div className="flex flex-col-reverse md:flex-row gap-5 items-middle items-end w-full mb-5">
            <div className="flex justify-between items-end w-full">
              <div>
                <label className="block text-xs md:text-base text-gray-700 mb-1">
                  Select Date Range:
                </label>

                <select
                  className="px-4 py-2 text-xs md:text-base rounded-md bg-white border"
                  value={selectedRange}
                  onChange={handleRangeChange}
                >
                  <option value="today">Today</option>
                  <option value="last7days">Last 7 Days</option>
                  <option value="last15days">Last 15 Days</option>
                  <option value="lastMonth">last Month</option>
                  <option value="customDate">Date Range</option>
                </select>
              </div>

              <BlackButton
                title="Filter"
                handleSubmit={() => setShowFilterPopUp(true)}
              />
            </div>
            <div>
              {selectedRange === "customDate" && (
                <div className="flex flex-row items-center gap-4">
                  <div>
                    <label className="block text-xs md:text-base text-gray-700 mb-1">
                      Start Date:
                    </label>
                    <input
                      type="date"
                      className="px-1 py-1 text-sm md:text-base md:px-4 md:py-2 border rounded-md"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div>
                    <label className="block text-sm md:text-base text-gray-700 mb-1">
                      End Date:
                    </label>
                    <input
                      type="date"
                      className="px-1 py-1 text-xs md:text-base md:px-4 md:py-2 border rounded-md"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>

            {selectedRange === "customDate" && (
              <button
                onClick={FilterHandler}
                className="bg-black p-2 px-5 text-white rounded-md"
              >
                Apply
              </button>
            )}
          </div> */}
          <div className="flex items-center justify-between mb-2 gap-2 capitalize">
            {Object.entries(analytics?.report || {}).map(
              ([key, value], index) => (
                <StatCard
                  key={key}
                  label={key.replace(/_/g, " ")}
                  value={value}
                  onClick={() => setPopUpType(key)}
                  // backgroundColor={ColorCardCode[index]}
                />
              ),
            )}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 mb-6 gap-2 capitalize">
            <StatCard
              // key={key}
              label={"Broadcart/Whatsapp"}
              value={"00"}
              // onClick={() => setPopUpType(key)}
              // backgroundColor={ColorCardCode[index]}
            />
            <StatCard
              // key={key}
              label={"Broadcart/Email"}
              value={"00"}
              // onClick={() => setPopUpType(key)}
              // backgroundColor={ColorCardCode[index]}
            />
            <StatCard
              // key={key}
              label={"Product/Active"}
              value={"12"}
              // onClick={() => setPopUpType(key)}
              // backgroundColor={ColorCardCode[index]}
            />
            <StatCard
              // key={key}
              label={"Product/Draft"}
              value={"12"}
              // onClick={() => setPopUpType(key)}
              // backgroundColor={ColorCardCode[index]}
            />
          </div>
          <InsightsContainer className="mb-2">
            <CartContainer
              label="Stores"
              permissions={permissions}
              onClick={() =>
                setPopupAnalics({
                  type: Line,
                  title: "Stores",
                  subTitle: "",
                  data: storeData,
                })
              }
              className="col-span-3"
            >
              <Line
                data={CatalogData(storeData)}
                style={{ height: "", width: "" }}
              />
            </CartContainer>

            <CartContainer
              label="States"
              permissions={permissions}
              onClick={() =>
                setPopupAnalics({
                  type: Bar,
                  title: "States",
                  subTitle: "",
                  data: stateWeekData,
                })
              }
              className="col-span-3"
            >
              <Bar
                data={CatalogData(stateWeekData)}
                style={{ height: "", width: "" }}
              />
            </CartContainer>
          </InsightsContainer>

          <InsightsContainer>
            <CartContainer
              label="Users"
              permissions={permissions}
              onClick={() =>
                setPopupAnalics({
                  type: Line,
                  title: "Users",
                  subTitle: "",
                  data: userAnalyticData,
                })
              }
              className="col-span-3"
            >
              <Line
                data={CatalogData(storeData)}
                style={{ height: "", width: "" }}
              />
            </CartContainer>
          </InsightsContainer>

          {/* <InsightsContainer>
            <CartContainer>
              <SegmentedDonutChart
                title="Apps"
                total={9245}
                totalTitle="total apps"
                title1Value={5900}
                title1Title="Enabled"
                title2Title="Disabled"
                title2Value={310}
              />
            </CartContainer>
            <CartContainer>
              <Doughnut data={dummyGraph} />
            </CartContainer>
            <CartContainer>
              <SegmentedTrafficBar
                title={trafficData.title}
                subtitle={trafficData.subtitle}
                totalVisitors={trafficData.totalVisitors}
                segments={trafficData.segments}
              />
            </CartContainer>
          </InsightsContainer> */}

          {/* <InsightsContainer> */}
          {/* <CartContainer className="col-span-6 grid grid-cols-6 gap-4">
              <div className="col-span-4">
                <Line
                  data={CatalogData(storeData)}
                  style={{ height: "", width: "" }}
                />
              </div>

              <div className="w-full h-full border rounded-lg p-4 bg-gray-50 space-y-4 col-span-2"> */}
          {/* <div className="space-y-4">
                  
                  <div className="flex items-center bg-blue-100 p-4 rounded-lg shadow">
                    <div className="bg-blue-500 text-white p-3 rounded-full">
                      📈
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-gray-600">Total Views</p>
                      <p className="text-lg font-semibold text-blue-800">
                        12,345
                      </p>
                    </div>
                  </div>
                 
                  <div className="flex items-center bg-green-100 p-4 rounded-lg shadow">
                    <div className="bg-green-500 text-white p-3 rounded-full">
                      🛒
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-gray-600">Total Sales</p>
                      <p className="text-lg font-semibold text-green-800">
                        $56,789
                      </p>
                    </div>
                  </div>
                 
                  <div className="flex items-center bg-yellow-100 p-4 rounded-lg shadow">
                    <div className="bg-yellow-500 text-white p-3 rounded-full">
                      🧑‍🤝‍🧑
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-gray-600">New Users</p>
                      <p className="text-lg font-semibold text-yellow-800">
                        1,234
                      </p>
                    </div>
                  </div>
               
                  <div className="flex items-center bg-red-100 p-4 rounded-lg shadow">
                    <div className="bg-red-500 text-white p-3 rounded-full">
                      💬
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-gray-600">Feedback</p>
                      <p className="text-lg font-semibold text-red-800">320</p>
                    </div>
                  </div>
                </div> */}
          {/* <div className="text-xs capitalize">
                  <p className="text-zinc-600 font-medium ">Week 4</p>
                  <div className="px-3 py-1">
                    <span>Generated</span>
                    <span>
                      {storeData?.last4WeeksReport?.catalog_generated}
                    </span>
                  </div>
                  <div className="px-3 py-1">
                    <span>sent</span>
                    <span>{storeData?.last4WeeksReport?.catalog_sent}</span>
                  </div>
                  <div className="px-3 py-1">
                    <span>email</span>
                    <span>
                      {storeData?.last4WeeksReport?.catalog_sent_email}
                    </span>
                  </div>
                  <div className="px-3 py-1">
                    <span>whatsapp</span>
                    <span>
                      {storeData?.last4WeeksReport?.catalog_sent_whatsapp}
                    </span>
                  </div>
                  <div className="px-3 py-1">
                    <span>downloaded</span>
                    <span>
                      {storeData?.last4WeeksReport?.catalog_downloaded}
                    </span>
                  </div>
                  <div className="px-3 py-1">
                    <span>orders</span>
                    <span>{storeData?.last4WeeksReport?.order_placed}</span>
                  </div>
                </div>
              </div>
            </CartContainer>
          </InsightsContainer> */}
          {/* <InsightsContainer>
            <CartContainer
              label="Broadcasts"
              permissions={permissions}
              onClick={() => setPopupAnalics({ type: Line, data: "" })}
              className="col-span-3"
            >
              <Line data={dummyGraph} style={{ height: "", width: "" }} />
            </CartContainer>

            <CartContainer
              label="Stores"
              permissions={permissions}
              onClick={() => setPopupAnalics({ type: Line, data: "" })}
              className="col-span-3"
            >
              <Line data={dummyGraph} style={{ height: "", width: "" }} />
            </CartContainer>
          </InsightsContainer> */}
        </div>
      </Container>
    </Layout>
  );
}

export default AnalyticsReport;

const StatCard = ({ label, value, key, onClick, backgroundColor }) => (
  <div
    className="cursor-pointer hover:bg-zinc-100 text-center w-full shadow rounded-md py-3"
    key={key}
    onClick={onClick}
    style={{ backgroundColor: backgroundColor ? backgroundColor : "#fff" }}
  >
    <p className="text-base md:text-xl lg:text-3xl font-semibold text-gray-800">
      {value}
    </p>
    <p className="text-xs md:text-xs font-medium text-gray-500">{label}</p>
  </div>
);

const InsightsContainer = ({ children, className }) => (
  <div className={`w-full gap-1 lg:gap-2 my-1 grid grid-cols-6 ${className}`}>
    {children}
  </div>
);

const CartContainer = ({
  children,
  permissions,
  onClick,
  label,
  className = "",
}) => (
  <div
    className={`shadow-sm   drop-shadow-md hover:shadow-2xl  bg-white rounded-lg  cursor-pointer p-4 col-span-2 ${className} ${
      permissions?.analytics === true && ""
    } w-full  bg-white/100  p-3`}
    onClick={onClick}
  >
    {label && <label className="text-zinc-500 font-semibold">{label}</label>}
    {children}
  </div>
);

const GraphItem = ({ label, value }) => (
  <div className="px-3 py-1 flex justify-between items-center">
    <span>{label}</span>
    <span>{value ?? "-"}</span>
  </div>
);

const WeeklyReport = ({ weekLabel, reportData }) => {
  const reportItems = [
    { label: "Generated", value: reportData?.catalog_generated },
    { label: "Sent", value: reportData?.catalog_sent },
    { label: "Email", value: reportData?.catalog_sent_email },
    { label: "WhatsApp", value: reportData?.catalog_sent_whatsapp },
    { label: "Downloaded", value: reportData?.catalog_downloaded },
    { label: "Orders", value: reportData?.order_placed },
  ];

  return (
    <div className="col-span-1">
      <p className="w-full text-zinc-600 font-medium">{weekLabel}</p>
      <div className="border-r">
        {reportItems.map((item, index) => (
          <GraphItem key={index} label={item.label} value={item.value} />
        ))}
      </div>
    </div>
  );
};
